<div id="notification-container" [class.notification-continues]="!getNotification.success">

  <div class="content main-header">
    <div class="content-container size-limit-250">Store</div>
    <div class="content-container size-limit-200">User</div>
  </div>

  <div class="content">
    <div class="content-container size-limit-250">{{ selectedStore.name }}</div>
    <div [title]="getNotification.userId" class="content-container size-limit-200">{{ getUserDetail }}</div>
  </div>


  <div class="mobile-content">

    <div class="mobile-content-container">
      <div class="main-header">Store</div>
      <span></span>
      <div>{{ selectedStore.name }}</div>
    </div>

    <div class="mobile-content-container">
      <div class="main-header">User</div>
      <span></span>
      <div [title]="getNotification.userId">{{ getUserDetail }}</div>
    </div>

    <div class="mobile-content-container status-container">
      <div class="main-header">Status</div>
      <span></span>
      <div>
        <div [ngClass]="getNotification.success ? 'dot-success' : 'dot-fail'">
          {{ getNotification.success ? 'SUCCESS' : 'FAILED' }}
        </div>
      </div>
    </div>

  </div>

</div>
